(function () {
    document.querySelectorAll('[data-sticky-atc]').forEach(function (sticky) {
      sticky.hidden = false;
      // Lift the bar to <body> so its fixed positioning + z-index sit in the
      // root stacking context, above the footer. Inside #main-content it gets
      // trapped below the footer because the page-transition opacity makes
      // #main-content a stacking context while the footer is its sibling
      // (footer-group), painting on top. (DEVELOPATH-326)
      if (sticky.parentElement !== document.body) document.body.appendChild(sticky);
      const mainAtc = document.querySelector('.main-product [data-add-to-cart]');
      const mainForm = document.querySelector('.main-product form');
      const mainLabel = document.querySelector('.main-product [data-atc-label]');
      const mainPrice = document.querySelector('.main-product [data-product-price]');
      const stickyButton = sticky.querySelector('[data-sticky-atc-button]');
      const stickyLabel = sticky.querySelector('[data-sticky-atc-label]');
      const stickyPrice = sticky.querySelector('[data-sticky-atc-price]');

      if (!mainAtc || !mainForm) {
        sticky.hidden = true;
        return;
      }

      // Reveal sticky bar when the main ATC is offscreen
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Show sticky when the main ATC is NOT visible
            const visible = entry.isIntersecting;
            sticky.setAttribute('data-visible', String(!visible));
          });
        }, { threshold: 0.1 });
        io.observe(mainAtc);
      }

      // Forward sticky click to the real form so existing async-ATC logic runs.
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          if (stickyButton.disabled) return;
          // requestSubmit so submit handler in main-product picks it up
          if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
          else mainForm.submit();
        });
      }

      // Sync state with the main ATC (label + disabled) on variant changes.
      function syncFromMain() {
        if (mainAtc && stickyButton) {
          stickyButton.disabled = mainAtc.disabled;
          stickyButton.setAttribute('aria-disabled', String(mainAtc.disabled));
        }
        if (mainLabel && stickyLabel) {
          stickyLabel.textContent = mainLabel.textContent || stickyLabel.textContent;
        }
        if (mainPrice && stickyPrice) {
          stickyPrice.replaceChildren(...Array.from(mainPrice.cloneNode(true).childNodes));
        }
      }
      document.addEventListener('variant:change', syncFromMain);
      syncFromMain();
    });
  })();
